<script lang="ts">
  import dayjs from "dayjs";
  import { from, timer } from "rxjs";
  import { concatMap, takeWhile } from "rxjs/operators";
  import { onMount } from "svelte";
  import type { Order } from "../../@types/api";
  import Button from "../components/Button.svelte";
  import { loading } from "../store";

  export let getOrder: (id: string) => Promise<Order>;
  export let category: "GAME" | "TELECOMMUNICATION" | "BILL" | "IDD";

  const param = new URLSearchParams(location.search);
  export let orderId = param.get("orderId");
  export let status = param.get("status");
  let isCancelled = status === "CANCELLED";

  let order: Order | null;
  let isShowPopout = false;

  $: if (order && order.status === "COMPLETED") {
    if (category === "GAME" || category === "BILL") {
      setTimeout(() => {
        location.href = `${location.protocol}${location.hostname}/order/${order.id}`
      }, 2000)
    }
  }

  onMount(() => {
    loading.set(false);
    if (status !== "CANCELLED") {
      const order$ = timer(0, 1500)
        .pipe(
          concatMap(() => from(getOrder(orderId)).pipe()),
          takeWhile(
            ({ status }) => ["COMPLETED", "FAILED"].indexOf(status) === -1,
            true,
          ),
        )
        .subscribe((item) => {
          order = item;

          if (order.appName === "FULL RICH" && order.status === "PENDING" && order.transactionId !== "" && !isShowPopout) {
            MessageInvoker.postMessage(`{"type":"confirm_transaction", "data":{"id":${Number(order.transactionId)}}}`);
            isShowPopout = true
          }
        });

      return () => {
        order$.unsubscribe();
      };
    }
  });

  const formatDateTime = (datetime: string) => {
    return dayjs(datetime).format("YYYY-MM-DD HH:mm:ss")
  }

  const goBack = () => {
    location.replace(`https://${location.hostname}`);
  };
</script>

{#if order}
  <div class="popup">
    {#if order?.status === "COMPLETED"}
      <i>
        <svg
          width="59"
          height="58"
          viewBox="0 0 59 58"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M29.5 57.8C45.4058 57.8 58.3 44.9058 58.3 29C58.3 13.0942 45.4058 0.199997 29.5 0.199997C13.5942 0.199997 0.699951 13.0942 0.699951 29C0.699951 44.9058 13.5942 57.8 29.5 57.8ZM42.8455 24.3456C44.2514 22.9397 44.2514 20.6603 42.8455 19.2544C41.4397 17.8485 39.1603 17.8485 37.7544 19.2544L25.9 31.1088L21.2455 26.4544C19.8396 25.0485 17.5603 25.0485 16.1544 26.4544C14.7485 27.8603 14.7485 30.1397 16.1544 31.5456L23.3544 38.7456C24.7603 40.1515 27.0396 40.1515 28.4455 38.7456L42.8455 24.3456Z"
            fill="#27AE60"
          />
        </svg>
      </i>
      {#if category === "TELECOMMUNICATION"}
        <h1 style="margin-bottom: 25px;">Top-up Success</h1>
        <div class="detail">Order ID : {order.id}</div>
        <div class="detail">Telco : {order.name}</div>
        <div class="detail">Amount : RM{order.amount.toFixed(2)}</div>
        <div class="detail">Beneficial ID : {order.beneficialId}</div>
        <div class="detail">Date Time : {formatDateTime(order.createdAt)}</div>
      {:else}
        <h1 style="margin-bottom: 25px;">Order Success</h1>
        <div class="detail">Order ID : {order.id}</div>
        <div class="detail">Product : {order.name}</div>
        <div class="detail">Amount : RM{order.amount.toFixed(2)}</div>
        <div class="detail">Date Time : {formatDateTime(order.createdAt)}</div>
      {/if}
      <Button on:click={goBack}>Back to home</Button>
    {:else if order?.status === "FAILED"}
      <i>
        <svg
          width="59"
          height="58"
          viewBox="0 0 59 58"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M29.5 57.8C45.4058 57.8 58.3 44.9058 58.3 29C58.3 13.0942 45.4058 0.199997 29.5 0.199997C13.5942 0.199997 0.699951 13.0942 0.699951 29C0.699951 44.9058 13.5942 57.8 29.5 57.8ZM24.8455 19.2544C23.4397 17.8485 21.1603 17.8485 19.7544 19.2544C18.3485 20.6603 18.3485 22.9397 19.7544 24.3456L24.4088 29L19.7544 33.6544C18.3485 35.0603 18.3485 37.3397 19.7544 38.7456C21.1603 40.1515 23.4397 40.1515 24.8455 38.7456L29.5 34.0912L34.1544 38.7456C35.5603 40.1515 37.8397 40.1515 39.2455 38.7456C40.6514 37.3397 40.6514 35.0603 39.2455 33.6544L34.5911 29L39.2455 24.3456C40.6514 22.9397 40.6514 20.6603 39.2455 19.2544C37.8397 17.8485 35.5603 17.8485 34.1544 19.2544L29.5 23.9088L24.8455 19.2544Z"
            fill="#EB5757"
          />
        </svg>
      </i>
      <h1>Top-up Failed!</h1>
      <div class="msg">Your top-up is failed, please try again.</div>
      <Button on:click={goBack}>Back</Button>
    {:else if order?.status === "CANCELLED" || isCancelled}
      <i>
        <svg
          width="59"
          height="58"
          viewBox="0 0 59 58"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M29.5 57.8C45.4058 57.8 58.3 44.9058 58.3 29C58.3 13.0942 45.4058 0.199997 29.5 0.199997C13.5942 0.199997 0.699951 13.0942 0.699951 29C0.699951 44.9058 13.5942 57.8 29.5 57.8ZM24.8455 19.2544C23.4397 17.8485 21.1603 17.8485 19.7544 19.2544C18.3485 20.6603 18.3485 22.9397 19.7544 24.3456L24.4088 29L19.7544 33.6544C18.3485 35.0603 18.3485 37.3397 19.7544 38.7456C21.1603 40.1515 23.4397 40.1515 24.8455 38.7456L29.5 34.0912L34.1544 38.7456C35.5603 40.1515 37.8397 40.1515 39.2455 38.7456C40.6514 37.3397 40.6514 35.0603 39.2455 33.6544L34.5911 29L39.2455 24.3456C40.6514 22.9397 40.6514 20.6603 39.2455 19.2544C37.8397 17.8485 35.5603 17.8485 34.1544 19.2544L29.5 23.9088L24.8455 19.2544Z"
            fill="#EB5757"
          />
        </svg>
      </i>
      <h1>Top-up Cancelled</h1>
      <div class="msg">You have cancelled the top-up.</div>
      <Button on:click={goBack}>Back to home</Button>
    {:else if order?.status === "PENDING" && order?.appName === "FULL RICH"}
      <h1 style="text-align:center;margin-bottom: 30px;">
        Your order is processing.
        <br/>
        Do not close this window.
      </h1>
    {:else if order?.status === "PROCESSING" && order?.appName === "FULL RICH"}
      <h1 style="text-align:center;margin-bottom: 30px;">
        Your order will be processed.
        <br/>
        You may close the app.
      </h1>
    {:else}
      <h1 style="text-align:center;margin-bottom: 30px;">
        Your top-up will be processed.
        <br/>
        You may close the app.
      </h1>
      <Button on:click={goBack}>Back to home</Button>
    {/if}
  </div>
{/if}

<style lang="scss">
  .popup {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 20px;
    align-items: center;
    justify-content: center;
  }

  .msg {
    padding: 30px 0;
    text-align: center;
    word-wrap: break-word;
    word-break: normal;
  }

  .detail {
    font-size: 16px;
    margin-bottom: 10px;
  }
</style>
